
/**
 * Scrolls to the Forminator response message if it's visible on page load.
 *
 * @returns {void}
 */
export function doForminatorMessageFix() {
  window.addEventListener('load', () => {
    const alert = document
      .querySelector('.forminator-response-message');

    if (alert !== null && alert.getAttribute('aria-hidden') !== 'true') {
      alert.scrollIntoView({ behavior: 'smooth', });
    }
  });
}